import React from "react";

import {
    Dialog, DialogActions,
    DialogContent, DialogContentText,
    DialogTitle,
    Button,
    IconButton,
} from "@mui/material";

import CloseIcon from '@mui/icons-material/Close';

import SelectedProductsList from "./SelectedProductsList";

export default function ConfirmationPopup({ open, handleClose, onConfirm, content, loading, selectedProducts }) {
    return (
        <Dialog 
            open={open} 
            onClose={loading ? null : handleClose}
            PaperProps={{
                style: {
                    borderRadius: '12px',
                    padding: '8px'
                }
            }}
        >
            <DialogTitle style={{ fontWeight: 700, fontSize: '18px', color: '#111827' }}>
                Confirmer l'action en masse
            </DialogTitle>
            {!loading && (
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 16,
                        top: 16,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            )}
            <DialogContent>
                <DialogContentText style={{ color: '#4b5563', fontSize: '14px' }}>
                    {content}
                </DialogContentText>
                <SelectedProductsList selected={selectedProducts} />
            </DialogContent>
            <DialogActions style={{ padding: '16px 24px' }}>
                <Button 
                    onClick={handleClose} 
                    disabled={loading}
                    style={{ 
                        color: '#6b7280', 
                        textTransform: 'none', 
                        fontWeight: 600 
                    }}
                >
                    Annuler
                </Button>
                <Button 
                    onClick={onConfirm} 
                    disabled={loading}
                    variant="contained"
                    style={{ 
                        backgroundColor: '#4338ca', 
                        color: '#ffffff', 
                        textTransform: 'none', 
                        fontWeight: 600,
                        borderRadius: '8px',
                        padding: '8px 20px',
                        boxShadow: 'none'
                    }}
                >
                    {loading ? "Chargement..." : "Confirmer"}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
